import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { PlatformList } from "./../../dashboard/interact/interact";

@Component({
  selector: "app-platform-stats",
  templateUrl: "./platform-stats.component.html",
  styleUrls: ["./platform-stats.component.scss"],
})
export class PlatformStatsComponent implements OnInit {
  @Input() platformDetails: any;
  @Input() isAnyPlatformConnected: boolean;
  @Input() loading: boolean = false;
  platformList: PlatformList[] = [];

  constructor() {}

  ngOnInit(): void {
    this.updateData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.platformDetails && changes.platformDetails.currentValue) {
      this.updateData();
    }
  }

  updateData() {
    if (this.platformDetails) {
      this.platformList = [
        {
          platform: "WhatsApp",
          image: "assets/images/social/whatsapp.png",
          // isIntegrated: Boolean(this.platformDetails?.whatsapp_count > 0),
          isIntegrated: this.platformDetails.whatsapp_count != null,
          postCount: this.platformDetails?.whatsapp_count,
        },
        {
          platform: "Facebook",
          image: "assets/images/fb-new.svg",
          // isIntegrated: Boolean(this.platformDetails?.fb_count > 0),
          isIntegrated: this.platformDetails.fb_count != null,
          postCount: this.platformDetails?.fb_count,
        },
        {
          platform: "Google",
          image: "assets/images/Google_Messages_logo.svg",
          // isIntegrated: Boolean(this.platformDetails?.gmb_count > 0),
          isIntegrated: this.platformDetails.gmb_count != null,
          postCount: this.platformDetails?.gmb_count,
        },
        {
          platform: "SMS",
          image: "assets/images/icon_sms_fill.svg",
          // isIntegrated: Boolean(this.platformDetails?.sms_count > 0),
          isIntegrated: this.platformDetails.sms_count != null,
          postCount: this.platformDetails?.sms_count,
        },
        {
          platform: "Call",
          image: "assets/images/icon_call_fill.svg",
          // isIntegrated: Boolean(this.platformDetails?.call_count > 0),
          isIntegrated: this.platformDetails.call_count != null,
          postCount: this.platformDetails?.call_count,
        },
        {
          platform: "Instagram",
          image: "assets/images/inst.svg",
          isIntegrated: this.platformDetails.instagram_count != null,
          postCount: this.platformDetails?.instagram_count,
        },
      ];
    }
  }
}
